<template>
  <!-- Profile Modal -->
  <v-dialog v-model="modalDialog" max-width="725px">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Profile Information</h5>
        <button type="button" class="close" @click="method(employee)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="putProfileInfo">
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div
                class="alert alert-success alert-dismissible fade show"
                role="alert"
                v-if="message"
              >
                <strong>Success!</strong> {{ message }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="profile-img-wrap edit-img">
                <img
                  class="inline-block"
                  alt="user"
                  :src="media + passportPhoto"
                  v-if="passportPhoto"
                />
                <img
                  class="inline-block"
                  alt="user"
                  src="~@/assets/profiles/avatar-02.jpg"
                  v-if="!passportPhoto"
                />
                <div class="fileupload btn">
                  <span class="btn-text">edit</span>
                  <input
                    class="upload"
                    type="file"
                    ref="file"
                    accept="image/*"
                    @change="onFilePicked"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>First Name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="$v.firstName.$model"
                      :class="{
                        'is-invalid': submitted && $v.firstName.$error
                      }"
                    />
                  </div>
                  <div
                    v-if="submitted && !$v.firstName.required"
                    class="invalid-feedback"
                  >
                    First Name is required
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Last Name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="$v.lastName.$model"
                      :class="{ 'is-invalid': submitted && $v.lastName.$error }"
                    />
                  </div>
                  <div
                    v-if="submitted && !$v.lastName.required"
                    class="invalid-feedback"
                  >
                    Last Name is required
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Birth Date</label>
                    <div class="cal-icon">
                      <datepicker
                        v-model.trim="$v.birthday.$model"
                        bootstrap-styling
                        class="datetimepicker"
                        type="date"
                        :class="{
                          'is-invalid': submitted && $v.birthday.$error
                        }"
                      />
                    </div>
                    <div
                      v-if="submitted && !$v.birthday.required"
                      class="invalid-feedback"
                    >
                      Birth Date is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Gender</label>
                    <select
                      class="select form-control"
                      v-model.trim="$v.gender.$model"
                      :class="{ 'is-invalid': submitted && $v.gender.$error }"
                    >
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                  </div>
                  <div
                    v-if="submitted && !$v.gender.required"
                    class="invalid-feedback"
                  >
                    Gender is required
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Address</label>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="$v.address.$model"
                  :class="{ 'is-invalid': submitted && $v.address.$error }"
                />
              </div>
              <div
                v-if="submitted && !$v.address.required"
                class="invalid-feedback"
              >
                Address is required
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="$v.phone.$model"
                  :class="{ 'is-invalid': submitted && $v.phone.$error }"
                />
              </div>
              <div
                v-if="submitted && !$v.phone.required"
                class="invalid-feedback"
              >
                Phone is required
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>State</label>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="$v.state.$model"
                  :class="{ 'is-invalid': submitted && $v.state.$error }"
                />
              </div>
              <div
                v-if="submitted && !$v.state.required"
                class="invalid-feedback"
              >
                State is required
              </div>
            </div>
            <div class="col-md-6" v-if="currentUser.roles.includes('HRAdmin')">
              <div class="form-group">
                <label>Admin. Approver</label>

                <multiselectvue
                  class="from-control"
                  v-model="employeeId"
                  placeholder="Select Manager"
                  :custom-label="nameOfEmployee"
                  :options="sortedEmployeeNames"
                  :searchable="true"
                  @select="optionSelected"
                  :allow-empty="false"
                >
                  <template slot="singleLabel" slot-scope="{ option }"
                    >{{ option.firstName }} {{ option.lastName }}</template
                  >
                </multiselectvue>

                <!-- <select class="form-control" v-model="manager">
                  <option>Select Staff</option>
                  <option
                    v-for="member in employees"
                    :key="member.id"
                    :value="member.id"
                  >
                    {{ member.lastName + " " + member.firstName }}
                  </option>
                </select> -->
              </div>
            </div>
            <div class="col-md-6" v-if="currentUser.roles.includes('HRAdmin')">
              <div class="form-group">
                <label>Expense Approver</label>

                <multiselectvue
                  class="from-control"
                  v-model="optEmployeeId"
                  placeholder="Select Manager"
                  :custom-label="nameOfEmployee"
                  :options="sortedEmployeeNames"
                  :searchable="true"
                  @select="optionOptSelected"
                  :allow-empty="false"
                >
                  <template slot="singleLabel" slot-scope="{ option }"
                    >{{ option.firstName }} {{ option.lastName }}</template
                  >
                </multiselectvue>

                <!-- <select class="form-control" v-model="manager">
                  <option>Select Staff</option>
                  <option
                    v-for="member in employees"
                    :key="member.id"
                    :value="member.id"
                  >
                    {{ member.lastName + " " + member.firstName }}
                  </option>
                </select> -->
              </div>
            </div>
            <div class="col-md-6" v-if="currentUser.roles.includes('HRAdmin')">
              <div class="form-group">
                <label>Admin. II Approver</label>

                <multiselectvue
                  class="from-control"
                  v-model="employee2Id"
                  placeholder="Select Manager"
                  :custom-label="nameOfEmployee"
                  :options="sortedEmployeeNames"
                  :searchable="true"
                  @select="optionIISelected"
                  :allow-empty="false"
                >
                  <template slot="singleLabel" slot-scope="{ option }"
                    >{{ option.firstName }} {{ option.lastName }}</template
                  >
                </multiselectvue>

                <!-- <select class="form-control" v-model="manager">
                  <option>Select Staff</option>
                  <option
                    v-for="member in employees"
                    :key="member.id"
                    :value="member.id"
                  >
                    {{ member.lastName + " " + member.firstName }}
                  </option>
                </select> -->
              </div>
            </div>
            <div class="col-md-6" v-if="currentUser.roles.includes('HRAdmin')">
              <div class="form-group">
                <label>Expense II Approver</label>

                <multiselectvue
                  class="from-control"
                  v-model="optEmployee2Id"
                  placeholder="Select Manager"
                  :custom-label="nameOfEmployee"
                  :options="sortedEmployeeNames"
                  :searchable="true"
                  @select="optionOptIISelected"
                  :allow-empty="false"
                >
                  <template slot="singleLabel" slot-scope="{ option }"
                    >{{ option.firstName }} {{ option.lastName }}</template
                  >
                </multiselectvue>

                <!-- <select class="form-control" v-model="manager">
                  <option>Select Staff</option>
                  <option
                    v-for="member in employees"
                    :key="member.id"
                    :value="member.id"
                  >
                    {{ member.lastName + " " + member.firstName }}
                  </option>
                </select> -->
              </div>
            </div>
          </div>
          <div class="submit-section">
            <button class="btn btn-primary submit-btn">Submit</button>
          </div>
        </form>
      </div>
    </div>
  </v-dialog>
  <!-- /Profile Modal -->
</template>

<script>
import { required, sameAs } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";
import { employeeService } from "@/services/employeeService";
import { authenticationService } from "@/services/authenticationService";
export default {
  components: {
    Datepicker
  },
  props: {
    model: {},
    dialog: Boolean,
    method: { type: Function }
  },
  data() {
    return {
      currentUser: authenticationService.currentUserValue,
      company: authenticationService.currentOfficeValue,
      passportPhoto: this.model.passportPhoto,
      media: "data:image/jpeg;base64,",
      modalDialog: this.dialog,
      employee: null,
      employees: [],
      firstName: this.model.firstName,
      lastName: this.model.lastName,
      birthday: this.model.birthday,
      gender: this.model.gender,
      address: this.model.address,
      phone: this.model.phone,
      state: this.model.state,
      manager: this.model.employeeManager
        ? this.model.employeeManager.managerId
        : 0,
      optManager: this.model.operationalEmployeeManager
        ? this.model.operationalEmployeeManager.managerId
        : 0,
      stage2Manager: this.model.employeeStage2Manager
        ? this.model.employeeStage2Manager.managerId
        : 0,
      optStage2Manager: this.model.operationalEmployeeStage2Manager
        ? this.model.operationalEmployeeStage2Manager.managerId
        : 0,
      message: "",
      error: "",
      file: null,
      submitted: false.valueOf,
      employeeId: this.model.employeeManager
        ? this.model.employeeManager.manager.firstName + " " + this.model.employeeManager.manager.lastName
        : "",
      optEmployeeId: this.model.operationalEmployeeManager
        ? this.model.operationalEmployeeManager.manager.firstName + " " + this.model.operationalEmployeeManager.manager.lastName
        : "",
      employee2Id: this.model.employeeStage2Manager
        ? this.model.employeeStage2Manager.manager.firstName + " " + this.model.employeeManager.manager.lastName
        : "",
      optEmployee2Id: this.model.operationalEmployeeStage2Manager
        ? this.model.operationalEmployeeStage2Manager.manager.firstName + " " + this.model.operationalEmployeeManager.manager.lastName
        : ""
    };
  },

  validations: {
    firstName: { required },
    lastName: { required },
    phone: { required },
    birthday: { required },
    address: { required },
    gender: { required },
    state: { required }
  },

  computed: {
    sortedEmployeeNames: function() {
      function compare(a, b) {
        if (a.firstName.toLowerCase() < b.firstName.toLowerCase()) return -1;
        if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) return 1;
        return 0;
      }

      return this.employees.sort(compare);
    }
  },
  mounted() {
    this.GetEmployees();
    this.$emit("update:employee", this.employee);
    this.$emit("update:profileDialog", this.dialog);
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
  },
  methods: {
    nameOfEmployee({ firstName, lastName }) {
      return `${firstName} ${lastName}`;
    },

    optionSelected(option, id) {
      console.log(option.id, this.employeeId);
      this.manager = option.id;
    },

    optionIISelected(option, id) {
      console.log(option.id, this.employee2Id);
      this.stage2Manager = option.id;
    },

    optionOptSelected(option, id) {
      console.log(option.id, this.optEmployeeId);
      this.optManager = option.id;
    },

    optionOptIISelected(option, id) {
      console.log(option.id, this.optEmployee2Id);
      this.optStage2Manager = option.id;
    },

    onFilePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.file = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.file = files[0];
      employeeService.changeEmployeePhoto(files[0], this.model.id).then(
        m => {
          this.passportPhoto = m.passportPhoto;
        },
        e => (this.error = e.title)
      );
    },
    putProfileInfo() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      console.log('Manager', this.manager)
      console.log('Manager2', this.stage2Manager)
      console.log('Opt Manager', this.optManager)
      console.log('Opt Manager2', this.optStage2Manager)
      this.model.firstName = this.firstName;
      (this.model.lastName = this.lastName),
        (this.model.phone = this.phone),
        (this.model.birthday = this.birthday),
        (this.model.gender = this.gender),
        (this.model.address = this.address),
        (this.model.state) = this.state,
        this.manager != 0
          ? this.model.employeeManager
            ? (this.model.employeeManager.managerId = this.manager)
            : (this.model.employeeManager = {
                employeeId: this.model.id,
                managerId: this.manager
              })
          : null;
        this.optManager != 0
          ? this.model.operationalEmployeeManager
            ? (this.model.operationalEmployeeManager.managerId = this.optManager)
            : (this.model.operationalEmployeeManager = {
                employeeId: this.model.id,
                managerId: this.optManager
              })
          : null;
        this.stage2Manager != 0
          ? this.model.employeeStage2Manager
            ? (this.model.employeeStage2Manager.managerId = this.stage2Manager)
            : (this.model.employeeStage2Manager = {
                employeeId: this.model.id,
                managerId: this.stage2Manager
              })
          : null;
        this.optStage2Manager != 0
          ? this.model.operationalEmployeeStage2Manager
            ? (this.model.operationalEmployeeStage2Manager.managerId = this.optStage2Manager)
            : (this.model.operationalEmployeeStage2Manager = {
                employeeId: this.model.id,
                managerId: this.optStage2Manager
              })
          : null;

      employeeService
        .updateEmployeeProfileInfo(this.model.id, this.model)
        .then(d => {
          this.message = "Profile Info update successfully!";
          employeeService.getEmployeeDetail(this.model.id).then(
            model => {
              this.employee = model;

              if (!this.employee.employeePension) {
                this.employee.employeePension = {
                  id: 0,
                  pensionNo: "",
                  employeeRate: 0,
                  pensionManager: ""
                };
              }
              if (!this.employee.employeeStatutory) {
                this.employee.employeeStatutory = {
                  id: 0,
                  salaryBasis: "",
                  salaryAmount: 0.0
                };
              }
              if (!this.employee.employeeTax) {
                this.employee.employeeTax = {
                  id: 0,
                  tin: "",
                  taxCode: "",
                  taxOffice: "",
                  tax: {}
                };
              } else {
                this.employee.employeeTax.tax = {
                  taxOffice: this.employee.employeeTax.taxCode,
                  description: this.employee.employeeTax.taxOffice
                };
              }
              employeeService.getEmployeeOtherDetail(this.$route.params.id).then(
        model => {

          this.employee.employeeBank = model.employeeBank;
          this.employee.employeeTax = model.employeeTax;
          this.employee.employeePension = model.employeePension;
          this.employee.employeeStatutory = model.employeeStatutory;
          this.employee.employeeEducations = model.employeeEducations;
          this.employee.employeeExperiences = model.employeeExperiences;
          this.employee.employeeEmergencies = model.employeeEmergencies;
          this.employee.employeeFamilies = model.employeeFamilies;
          this.employee.employeeGLIs = model.employeeGLIs;
          this.employee.employeeHMO = model.employeeHMO;
          this.employee.employeeNextOfKin = model.employeeNextOfKin;
          this.employee.employeeNHF = model.employeeNHF;

          console.log(this.employee.employeeBank);

          if (!this.employee.employeePension) {
            this.employee.employeePension = {
              id: 0,
              pensionNo: "",
              employeeRate: "0",
              pensionManager: ""
            };
          } else {
            this.employee.employeePension.employeeRate = model.employeePension.employeeRate.toString();
          }
          if (!this.employee.employeeStatutory) {
            this.employee.employeeStatutory = {
              id: 0,
              salaryBasis: "",
              salaryAmount: 0.0
            };
          }
          if (!this.employee.employeeTax) {
            this.employee.employeeTax = {
              id: 0,
              tin: "",
              taxCode: "",
              taxOffice: "",
              tax: {}
            };
          } else {
            this.employee.employeeTax.tax = {
              taxOffice: this.employee.employeeTax.taxCode,
              description: this.employee.employeeTax.taxOffice
            };
          }
          if (!this.employee.employeeNHF) {
            this.employee.employeeNHF = {
              id: 0,
              nhfNo: "",
              state: ""
            };
          }
          this.method(this.employee);
        },
        error => {
          this.error = error;
        }
      );
    
            },
            error => {
              this.error = error;
            }
          );
        });
    },
    GetEmployees() {
      employeeService.getAllEmployees(this.company.id).then(
        model => {
          this.employees = model;

        },
        error => {
          this.error = error;
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/employees/ProfileModal.vue